export default {
  "path": "/demo/preview",
  "meta": {
    "name": "demo-Preview 业务预览（审批、合同、企业等）",
    "title": "Preview 业务预览（审批、合同、企业等）",
    "isComponentDoc": true,
    "category": "Text"
  }
};